export const HTTP_HEADER = {
  CSRF_TOKEN: 'anti-csrftoken-a2z', // Amazon's standard CSRF header for API requests
  // Request ID stamped by OPF and echoed on the response. Joins to Coral request.requestID,
  // RTLA requestId, OPF TrafficStream requestid and Clickstream request_id.
  AMZ_REQUEST_ID: 'x-amz-rid',
};
